<template>
  <div class="list-clients">
    <navigator :items="items"></navigator>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row">
                <div class="col-12">
                  <h5>Filtros</h5>
                </div>
                <div class="col-lg-2">
                  <div class="form-group">
                    <select v-model="filter.product" id class="form-control">
                      <option value="0">Todos os produtos</option>
                      <option
                        v-for="product in products"
                        :value="product.id"
                        v-bind:key="product.id"
                      >
                        {{ product.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group">
                    <select v-model="filter.type" id class="form-control">
                      <option value>Todos</option>
                      <option
                        v-for="type in types"
                        :value="type"
                        v-bind:key="type"
                      >
                        {{ type }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group">
                    <input
                      type="text"
                      v-model="filter.name"
                      placeholder="Nome"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group">
                    <input
                      type="text"
                      v-model="filter.login"
                      placeholder="Login"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group">
                    <input
                      type="text"
                      v-model="filter.email"
                      placeholder="E-mail"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-lg-2">
                  <button class="btn btn-primary" v-on:click="filterTable()">
                    Pesquisar
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <b-table
                    hover
                    :fields="fields"
                    :items="data"
                    :per-page="0"
                    :current-page="currentPage"
                    @row-clicked="selectItemTable"
                  >
                    <template v-slot:cell(user.name)="data">{{
                      data.value ? data.value : "-"
                    }}</template>
                  </b-table>
                  <div class="no-data" v-if="data.length == 0">
                    <span>Sem dados</span>
                  </div>
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import { bus } from "@/main";

export default {
  name: "list-clients",
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      items: [
        {
          text: "Clientes",
          active: true,
        },
        {
          text: "Novo Cliente",
          route: "admin.client",
        },
      ],
      data: [],
      fields: [
        { key: "name", label: "Nome" },
        { key: "type", label: "Tipo" },
        { key: "user.name", label: "Vendedor" },
        { key: "address.state", label: "Estado", centered: true },
        { key: "address.city", label: "Cidade", centered: true },
        { key: "status", label: "Situação", centered: true },
      ],
      filter: {
        name: "",
        login:"",
        email:"",
        product: 0,
        type: "",
      },
      products: [],
      types: [],
    };
  },
  mounted() {
    this.getSavedData();
    bus.$emit("changeLoading", true);
    this.providerData();
    this.getCreateParams();
  },
  watch: {
    currentPage: {
      handler: function (value) {
        this.providerData();
      },
    },
  },
  methods: {
    filterTable() {
      this.currentPage = 1;
      this.providerData();
    },
    providerData() {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/clients?${this.urlBuild()}`)
        .then((response) => {
          this.rows = response.data.total;
          this.data = response.data.data;
          bus.$emit("changeLoading", false);
        });
    },
    getSavedData: function () {
      if (
        localStorage.getItem("filters_search_clients") != null &&
        localStorage.getItem("filters_search_clients") != ""
      ) {
        var data = JSON.parse(localStorage.getItem("filters_search_clients"));
        this.filter = data.filter;
      }
    },
    saveDataOnStorage: function () {
      let filters = {
        filter: this.filter,
      };
      localStorage.setItem("filters_search_clients", JSON.stringify(filters));
    },
    urlBuild: function () {
      this.saveDataOnStorage();
      let url =
        "include=address,contact,user&page[number]=" +
        this.currentPage +
        "&page[size]=" +
        this.perPage +
        (this.filter.name != "" ? `&filter[name]=${this.filter.name}` : "") +
        (this.filter.login != undefined ? `&filter[users.login]=${this.filter.login}` : "") +
        (this.filter.email != undefined ? `&filter[contact.email]=${this.filter.email}`: "") +
        (this.filter.product != 0 ? `&filter[products.id]=${this.filter.product}` : "") +
        (this.filter.type != "" ? `&filter[type]=${this.filter.type}` : "");
      return url;
    },
    selectItemTable: function (record, index) {
      this.$router.push({ name: "admin.client", params: { id: record.id } });
    },
    getCreateParams: function () {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/clients/create`)
        .then((data) => {
          this.products = data.data.products;
          this.types = data.data.types;
        });
    },
    doEvent() {
      try {
        this.$el.dispatchEvent(new Event("eventtriggered"));
      } catch (e) {
        // handle IE not supporting Event constructor
        var evt = document.createEvent("Event");
        evt.initEvent("eventtriggered", true, false);
        this.$el.dispatchEvent(evt);
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.filter-row {
  margin-bottom: 14px;
}
</style>